import axios from 'axios';

export const customAxios = axios.create({
  baseURL: 'https://typeform-clone-resource-tripheo0412.now.sh',
});
